<!-- eslint-disable vue/no-mutating-props -->
<!-- 会员等级、成长值、积分与会员权益的弹窗模块。表单状态由父页面集中管理。 -->
<template>
  <el-dialog :model-value="memberLevelEditorVisible" :title="isEditingMemberLevel ? '编辑等级' : '新增等级'" width="780px" class="member-level-dialog" @update:model-value="emit('update:memberLevelEditorVisible', $event)">
    <div class="member-level-editor">
      <aside class="member-level-preview">
        <div class="member-level-preview__badge">{{ memberLevelPreviewBadge }}</div>
        <div class="member-level-preview__name">
          <strong>{{ memberLevelPreviewName }}</strong>
          <span>{{ memberLevelPreviewCode }}</span>
        </div>
        <div class="member-level-preview__metrics">
          <div>
            <small>成长门槛</small>
            <b>{{ memberLevelForm.growthThreshold ?? 0 }}</b>
          </div>
          <div>
            <small>会员折扣</small>
            <b>{{ memberLevelDiscountText }}</b>
          </div>
          <div>
            <small>积分倍率</small>
            <b>{{ memberLevelPointsText }}</b>
          </div>
        </div>
      </aside>
      <section class="member-level-form">
        <div class="member-level-form__section">
          <h3>基础信息</h3>
          <div class="member-level-fields">
            <label>
              <span>等级编码 <b>*</b></span>
              <el-input v-model.trim="memberLevelForm.code" placeholder="如 GOLD" />
            </label>
            <label>
              <span>等级名称 <b>*</b></span>
              <el-input v-model.trim="memberLevelForm.name" placeholder="如 黄金会员" />
            </label>
            <label class="member-level-fields__wide">
              <span>徽章文案</span>
              <el-input v-model.trim="memberLevelForm.badge" placeholder="展示在会员卡上的短文案" />
            </label>
          </div>
        </div>
        <div class="member-level-form__section">
          <h3>权益规则</h3>
          <div class="member-level-fields">
            <label>
              <span>成长门槛</span>
              <el-input v-model.number="memberLevelForm.growthThreshold" type="number" placeholder="0" />
            </label>
            <label>
              <span>折扣系数</span>
              <el-input v-model="memberLevelForm.discountRate" type="number" placeholder="1" />
            </label>
            <label>
              <span>积分倍率</span>
              <el-input v-model="memberLevelForm.pointsMultiplier" type="number" placeholder="1" />
            </label>
            <label>
              <span>排序值</span>
              <el-input v-model.number="memberLevelForm.sort" type="number" placeholder="0" />
            </label>
          </div>
        </div>
      </section>
    </div>
    <template #footer>
      <el-button @click="emit('update:memberLevelEditorVisible', false)">取消</el-button>
      <el-button type="primary" :disabled="!memberLevelForm.code || !memberLevelForm.name" @click="emit('submitMemberLevel')">
        {{ isEditingMemberLevel ? '保存修改' : '新增等级' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="growthRuleEditorVisible" :title="isEditingGrowthRule ? '编辑成长规则' : '新增成长规则'" width="560px" @update:model-value="emit('update:growthRuleEditorVisible', $event)">
    <div class="guided-form">
      <p class="guided-form__intro">成长值用于决定会员升级。当前成长场景固定为消费。</p>
      <div class="guided-form__section">
        <h3>规则内容</h3>
        <div class="guided-form__fields">
          <label class="guided-form__field">
            <span>成长场景 <b>*</b></span>
            <el-input model-value="消费" disabled />
            <small>用户完成消费后触发成长值累计。</small>
          </label>
          <label class="guided-form__field">
            <span>每消费 1 元获得成长值</span>
            <el-input v-model.number="growthRuleForm.growthValuePerYuan" type="number" min="1" step="1" placeholder="如 1" />
            <small>填写每消费 1 元可获得的成长值数量。</small>
          </label>
        </div>
      </div>
      <div class="guided-form__section guided-form__section--compact">
        <label class="guided-form__field">
          <span>规则状态</span>
          <el-select v-model="growthRuleForm.enabled">
            <el-option label="启用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
          <small>停用后不再按此规则累计成长值。</small>
        </label>
      </div>
    </div>
    <template #footer>
      <el-button @click="emit('update:growthRuleEditorVisible', false)">取消</el-button>
      <el-button type="primary" :disabled="!growthRuleForm.growthValuePerYuan || growthRuleForm.growthValuePerYuan <= 0" @click="emit('submitGrowthRule')">
        {{ isEditingGrowthRule ? '保存修改' : '新增规则' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="pointsRuleEditorVisible" :title="isEditingPointsRule ? '编辑积分规则' : '新增积分规则'" width="640px" @update:model-value="emit('update:pointsRuleEditorVisible', $event)">
    <div class="guided-form">
      <p class="guided-form__intro">积分可用于兑换或抵扣。当前积分场景固定为消费。</p>
      <div class="guided-form__section">
        <h3>积分发放</h3>
        <div class="guided-form__fields">
          <label class="guided-form__field">
            <span>积分场景 <b>*</b></span>
            <el-input model-value="消费" disabled />
            <small>用户完成消费后触发积分发放。</small>
          </label>
          <label class="guided-form__field">
            <span>每消费 1 元获得积分</span>
            <el-input v-model.number="pointsRuleForm.value" type="number" min="1" step="1" placeholder="如 1" />
            <small>填写每消费 1 元可获得的积分数量。</small>
          </label>
        </div>
      </div>
      <div class="guided-form__section guided-form__section--compact">
        <label class="guided-form__field">
          <span>规则状态</span>
          <el-select v-model="pointsRuleForm.enabled">
            <el-option label="启用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
          <small>停用后新订单不再按此规则发放积分。</small>
        </label>
      </div>
    </div>
    <template #footer>
      <el-button @click="emit('update:pointsRuleEditorVisible', false)">取消</el-button>
      <el-button type="primary" :disabled="!pointsRuleForm.value || pointsRuleForm.value <= 0" @click="emit('submitPointsRule')">
        {{ isEditingPointsRule ? '保存修改' : '新增规则' }}
      </el-button>
    </template>
  </el-dialog>

  <el-dialog :model-value="memberBenefitEditorVisible" :title="isEditingMemberBenefit ? '编辑会员权益' : '新增会员权益'" width="640px" @update:model-value="emit('update:memberBenefitEditorVisible', $event)">
    <div class="guided-form">
      <p class="guided-form__intro">权益会展示给对应等级的会员。等级编码需与“会员等级”页面中的编码完全一致，例如 <b>GOLD</b>。</p>
      <div class="guided-form__section">
        <h3>适用对象</h3>
        <div class="guided-form__fields">
          <label class="guided-form__field">
            <span>适用会员等级 <b>*</b></span>
            <el-select v-model="memberBenefitForm.levelCode" filterable placeholder="请选择会员等级">
              <el-option v-for="level in memberLevels" :key="level.code" :label="level.name || level.code" :value="level.code">
                <span>{{ level.name || level.code }}</span>
                <small class="option-code">{{ level.code }}</small>
              </el-option>
            </el-select>
            <small>选择等级名称，系统会保存对应的等级编码。</small>
          </label>
          <label class="guided-form__field">
            <span>权益类型</span>
            <el-input v-model.trim="memberBenefitForm.benefitType" placeholder="如 生日券、免配送费、新品试饮" />
            <small>填写会员能够获得的权益名称。</small>
          </label>
        </div>
      </div>
      <div class="guided-form__section">
        <h3>权益规则</h3>
        <div class="guided-form__fields">
          <label class="guided-form__field guided-form__field--wide">
            <span>权益说明</span>
            <el-input v-model.trim="memberBenefitForm.config" type="textarea" :rows="3" placeholder="如 每月可享 2 次免配送费，单次最高抵扣 8 元" />
            <small>说明会员能获得什么、领取或使用条件、次数和额度限制。</small>
          </label>
          <label class="guided-form__field">
            <span>展示排序</span>
            <el-input v-model.number="memberBenefitForm.sort" type="number" placeholder="数值越小越靠前" />
            <small>用于调整会员端权益的展示顺序。</small>
          </label>
          <label class="guided-form__field">
            <span>权益状态</span>
            <el-select v-model="memberBenefitForm.enabled">
              <el-option label="启用" :value="true" />
              <el-option label="停用" :value="false" />
            </el-select>
            <small>停用后会员端不再展示或使用该权益。</small>
          </label>
        </div>
      </div>
    </div>
    <template #footer>
      <el-button @click="emit('update:memberBenefitEditorVisible', false)">取消</el-button>
      <el-button type="primary" :disabled="!memberBenefitForm.levelCode" @click="emit('submitMemberBenefit')">
        {{ isEditingMemberBenefit ? '保存修改' : '新增权益' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { GrowthRuleConfig, MemberBenefitConfig, MemberLevelConfig, PointsRuleConfig } from '@/api/member'

type GrowthRuleEditorForm = GrowthRuleConfig & { growthValuePerYuan?: number }

const props = defineProps<{
  memberLevelEditorVisible: boolean
  growthRuleEditorVisible: boolean
  pointsRuleEditorVisible: boolean
  memberBenefitEditorVisible: boolean
  memberLevelForm: MemberLevelConfig
  growthRuleForm: GrowthRuleEditorForm
  pointsRuleForm: PointsRuleConfig
  memberBenefitForm: MemberBenefitConfig
  memberLevels: MemberLevelConfig[]
}>()

const emit = defineEmits<{
  'update:memberLevelEditorVisible': [value: boolean]
  'update:growthRuleEditorVisible': [value: boolean]
  'update:pointsRuleEditorVisible': [value: boolean]
  'update:memberBenefitEditorVisible': [value: boolean]
  submitMemberLevel: []
  submitGrowthRule: []
  submitPointsRule: []
  submitMemberBenefit: []
}>()

const isEditingMemberLevel = computed(() => Boolean(props.memberLevelForm.id))
const isEditingGrowthRule = computed(() => Boolean(props.growthRuleForm.id))
const isEditingPointsRule = computed(() => Boolean(props.pointsRuleForm.id))
const isEditingMemberBenefit = computed(() => Boolean(props.memberBenefitForm.id))
const memberLevelPreviewName = computed(() => props.memberLevelForm.name?.trim() || '新会员等级')
const memberLevelPreviewCode = computed(() => props.memberLevelForm.code.trim() || 'LEVEL_CODE')
const memberLevelPreviewBadge = computed(() => props.memberLevelForm.badge?.trim() || memberLevelPreviewName.value.slice(0, 1))
const memberLevelDiscountText = computed(() => {
  const value = Number(props.memberLevelForm.discountRate ?? 1)
  if (!Number.isFinite(value)) return '--'
  if (value >= 1) return '原价'
  const discount = value * 10
  return `${Number.isInteger(discount) ? discount : discount.toFixed(1)} 折`
})
const memberLevelPointsText = computed(() => {
  const value = Number(props.memberLevelForm.pointsMultiplier ?? 1)
  return Number.isFinite(value) ? `${value}x` : '--'
})
</script>

<style scoped lang="scss">
.member-level-editor { display: grid; grid-template-columns: 240px minmax(0, 1fr); gap: 16px; }
.member-level-preview { min-height: 286px; padding: 20px; border-radius: 12px; background: linear-gradient(145deg, #1f2937 0%, #3b4d61 56%, #9a7440 100%); color: #fff; display: flex; flex-direction: column; justify-content: space-between; overflow: hidden; position: relative; }
.member-level-preview::before { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, rgba(255, 255, 255, .18), transparent 44%); pointer-events: none; }
.member-level-preview > * { position: relative; z-index: 1; }
.member-level-preview__badge { width: 56px; height: 56px; border: 1px solid rgba(255, 255, 255, .36); border-radius: 14px; background: rgba(255, 255, 255, .16); display: grid; place-items: center; box-shadow: inset 0 1px 0 rgba(255, 255, 255, .22); font-size: 22px; font-weight: 800; }
.member-level-preview__name { display: flex; flex-direction: column; gap: 8px; }
.member-level-preview__name strong { font-size: 22px; line-height: 1.2; overflow-wrap: anywhere; }
.member-level-preview__name span { width: fit-content; max-width: 100%; padding: 5px 9px; border-radius: 999px; background: rgba(255, 255, 255, .16); color: rgba(255, 255, 255, .82); font-size: 12px; font-weight: 700; overflow-wrap: anywhere; }
.member-level-preview__metrics { display: grid; gap: 8px; }
.member-level-preview__metrics div { padding: 10px 12px; border: 1px solid rgba(255, 255, 255, .18); border-radius: 10px; background: rgba(255, 255, 255, .12); display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.member-level-preview__metrics small { color: rgba(255, 255, 255, .72); font-size: 12px; }
.member-level-preview__metrics b { font-size: 16px; }
.member-level-form { display: flex; flex-direction: column; gap: 14px; }
.member-level-form__section, .guided-form__section { padding: 16px; border: 1px solid var(--jf-color-border); border-radius: 12px; background: linear-gradient(180deg, #fff 0%, #fbfcfd 100%); }
.member-level-form__section h3, .guided-form__section h3 { margin: 0 0 14px; color: var(--jf-color-text-primary); font-size: 15px; }
.member-level-fields, .guided-form__fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px 16px; }
.member-level-fields label, .guided-form__field { min-width: 0; display: flex; flex-direction: column; gap: 6px; }
.member-level-fields span, .guided-form__field > span { color: var(--jf-color-text-secondary); font-size: 12px; font-weight: 700; }
.member-level-fields b, .guided-form__field > span b { color: var(--jf-color-error); }
.member-level-fields__wide, .guided-form__field--wide { grid-column: 1 / -1; }
.guided-form { display: flex; flex-direction: column; gap: 14px; }
.guided-form__intro { margin: 0; padding: 12px 14px; border-left: 3px solid var(--jf-color-primary); border-radius: 6px; background: rgba(118, 183, 232, .1); color: var(--jf-color-text-secondary); font-size: 13px; line-height: 1.65; }
.guided-form__intro b { color: var(--jf-color-primary-dark); font-weight: 800; }
.guided-form__section--compact { padding-bottom: 14px; }
.guided-form__field > small { min-height: 17px; color: var(--jf-color-text-secondary); font-size: 12px; line-height: 1.45; }
:deep(.option-code) { float: right; margin-left: 12px; color: var(--jf-color-text-secondary); font-size: 12px; }
@media (max-width: 760px) {
  .member-level-editor, .member-level-fields, .guided-form__fields { grid-template-columns: 1fr; }
  .member-level-preview { min-height: 220px; }
  .member-level-fields__wide, .guided-form__field--wide { grid-column: auto; }
}
</style>
